module.exports = __webpack_public_path__ + "media/Sixthsense_Credenciales_Sentidos.39b2a51a.mp4";